module.exports = __webpack_public_path__ + "static/fonts/iconfont.c2060d0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.ttf?t=1602470866315
// module id = VIfJ
// module chunks = 1